import { useCallback, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DistractionFreeMode, getFreeModeState, selectDistractionFreeMode, toggleDistractionFreeMode } from 'data/layout';
import { useToggleFreeMode } from 'hooks/use-toggle-free-mode';
export const useDistractionFreeMode = (key = undefined)=>{
    const dispatch = useDispatch();
    useLayoutEffect(()=>{
        const distractionFreeValue = getFreeModeState(key !== null && key !== void 0 ? key : '__distractionFree');
        dispatch(toggleDistractionFreeMode(distractionFreeValue));
    }, [
        dispatch,
        key
    ]);
    const distractionFreeActive = useSelector(selectDistractionFreeMode);
    const onToggle = useCallback((value)=>{
        dispatch(toggleDistractionFreeMode(value));
    }, [
        dispatch
    ]);
    const { active, exit, enter } = useToggleFreeMode({
        active: distractionFreeActive,
        localStorageKey: key !== null && key !== void 0 ? key : DistractionFreeMode,
        onToggle
    });
    return {
        active,
        exit,
        enter
    };
};
